<template>
  <b-container fluid>
    <h3>Accounts</h3>
    <hr />
    <!-- Grid -->
    <!-- <b-row v-if="!selectedAccount"> -->
    <div v-if="!selectedAccount">
      <b-row>
        <b-col>
          <b-button @click="onAddAccount" variant="blue" size="sm">
            <b-icon-plus />
            Add Account
          </b-button>
        </b-col>
      </b-row>
    </div>
    <b-row v-if="!selectedAccount">
      <b-col>
        <hr />
        <dx-data-grid
          :data-source="accounts"
          :columns="gridSettings.account.columns"
          :editing="gridSettings.account.editing"
          :master-detail="gridSettings.account.masterDetail"
          :onEditingStart="onSelection"
          :search-panel="gridSettings.account.searchPanel"
          :load-panel="{ enabled: true, showPane: true }"
          keyExpr="id"
          :height="725"
        >
          <template #detailTemp="account">
            <site-temp
              :tempData="account.data"
              @addSiteClick="onAddSite"
              :acctId="account.data.data.id"
            />
          </template>
        </dx-data-grid>
      </b-col>
    </b-row>

    <!-- Editor -->

    <b-row v-if="selectedAccount">
      <b-col>
        <b-overlay :show="isSubmitting">
          <router-view />
        </b-overlay>
      </b-col>
    </b-row>

    <!--v-else> -->
    <b-row v-if="false">
      <b-col>
        <b-form>
          <!-- Account Details -->
          <b-container>
            <h5 class="mb-3 text-center">
              Account Details
            </h5>
            <b-form-group
              label="Name:"
              :label-cols="1"
              :invalid-feedback="validationStat.name.msg"
            >
              <b-input
                type="text"
                v-model="selectedAccount.name"
                :maxlength="255"
                required
                @blur="onBlur($event.target)"
                ref="name"
                id="name"
              />
            </b-form-group>
            <b-form-group
              label="Account Number:"
              :label-cols="1"
              :invalid-feedback="validationStat.number.msg"
            >
              <b-input
                type="text"
                v-model="selectedAccount.number"
                :maxlength="255"
                required
                @blur="onBlur($event.target)"
                ref="number"
                id="number"
              />
            </b-form-group>
            <!-- Views -->
            <b-row class="mb-3">
              <b-col>
                <!-- <router-view /> -->
                <sites v-if="selectedAccount && !showSiteEditor" />
                <site-editor v-else />
              </b-col>
            </b-row>
          </b-container>
          <b-button variant="blue" @click="onSubmit" type="submit">
            Save
          </b-button>
          <b-button variant="orange" @click="onClancel">
            Cancel
          </b-button>
        </b-form>
        <hr />
        <b-row>
          <b-col> </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { confirm } from "devextreme/ui/dialog";
import SiteEdit from "./SiteEdit";
import Sites from "./sites";

import SiteTemp from "./SiteTemp";

export default {
  components: {
    Sites,
    SiteEdit,
    SiteTemp
  },
  data() {
    return {
      // validationStat: {
      //   name: {
      //     msg: ""
      //   },
      //   number: {
      //     msg: ""
      //   }
      // },
      isSubmitting: false,
      gridSettings: {
        account: {
          columns: [
            // {
            //   dataField: "number",
            //   caption: "Account No.",
            //   width: 200
            // },
            {
              dataField: "name",
              caption: "Account Name",
              sortOrder: "asc"
              // groupIndex: 0,
              // autoExpandGroup: true
            }
            // {
            //   caption: "Open Orders",
            //   width: 150,
            //   alignment: "center"
            // }
          ],
          selection: {
            allowSelectAll: false,
            mode: "single"
          },
          masterDetail: {
            enabled: true,
            autoExpandAll: true,
            template: "detailTemp"
          },
          editing: {
            allowUpdating: true
          },
          searchPanel: {
            highlightSearchText: true,
            visible: true,
            width: 250
          }
        }
      },
      showSites: false,
      showSiteEditor: false
    };
  },
  // beforeMount() {
  //   if (this.$store.getters["accounts/accounts"].length == 0) {
  //     var str = this.$store;
  //     return this.$store
  //       .dispatch("accounts/getAccounts")
  //       .then(() => this.$store.dispatch("accounts/getSaUsers"));
  //   } else {
  //     return this.$store.dispatch("accounts/getSaUsers");
  //   }
  // },
  beforeDestroy() {
    this.selectedAccount = null;
    return this.$store.dispatch("accounts/getAccounts");
  },
  computed: {
    accounts() {
      return this.$store.getters["accounts/accounts"];
    },
    sa() {
      return this.$store.getters["accounts/saUsers"];
    },
    selectedAccount: {
      get() {
        return this.$store.getters["accounts/currentAccount"];
      },
      set(val) {
        this.$store.dispatch("accounts/currentAccount", val);
      }
    },
    selectedSite: {
      get() {
        return this.$store.getters["accounts/currentSite"];
      },
      set(val) {
        this.$store.dispatch("accounts/currentSite", val);
      }
    },
    wasModified: {
      get() {
        return this.$store.getters["accounts/isDirty"];
      },
      set(val) {
        return this.$store.dispatch("accounts/flagChanges", val);
      }
    },
    isLoading() {
      if (!this.$store) {
        return true;
      }
      return this.$store.getters["isLoading"];
    }
  },
  methods: {
    onSelection(e) {
      debugger;
      // this.selectedAccount = e.data ? e.data : null;

      if (e.data) {
        //Account or site?
        if (e.data.account_id) {
          //It's a site:
          this.selectedSite = e.data;
          this.$store.dispatch("accounts/getCaUsers").then(() => {
            this.$router.push(
              "/account/" +
                e.data.name.trim().replace(" ", "_") +
                "/" +
                e.data.id
            );
          });
        } else if (e.data.id) {
          //It's an account:
          this.selectedAccount = e.data;
          this.$store.dispatch("accounts/getCaUsers").then(() => {
            this.$router.push(
              "/account/" + e.data.name.trim().replace(" ", "_")
            );
          });
        }
        return;
        this.$store.dispatch("accounts/getCaUsers").then(() => {
          var st = this.selectedAccount.sites ? this.selectedAccount.sites : [];
          this.$router.push({
            name: "sites",
            params: {
              sites: st
            }
          });
        });
      }
    },
    onClancel() {
      debugger;
      if (this.wasModified) {
        var msgBox = confirm(
          "<p>It appears that this may be a new account or made changes to it <br/> Are you sure you want to cancel these changes?</p>",
          "Confirmation"
        ).then(rsp => {
          debugger;

          if (rsp) {
            return this.reset();
            // return this.$store
            //   .dispatch("accounts/getAccounts")
            //   .then(() => (this.wasModified = false))
            //   .then(() => (this.selectedAccount = null));
          } else {
            return;
          }
        });
      } else {
        this.reset();
      }
    },
    onBlur(e) {
      debugger;

      var isStr = typeof e.value === "string";
      if (isStr) {
        this.selectedAccount[e.id] = e.value.trim();
      }
    },
    onAddAccount() {
      this.selectedAccount = {
        name: "New_Account",
        number: "",
        sites: [],
        orders: []
      };

      return this.$store.dispatch("accounts/flagChanges", true).then(() => {
        this.$router.push({ path: "/account/New_Account" });
      });

      //   this.$router.push({
      //     name: "sites",
      //     params: {
      //       sites: this.selectedAccount.sites
      //     }
      //   });
    },
    onAddSite(e) {
      debugger;
      this.selectedSite = e;
      //Get the account:
      var account = this.accounts.find(a => a.id === e.account_id);

      this.selectedAccount = account;

      this.$store.dispatch("accounts/getCaUsers").then(() => {
        debugger;
        var uri =
          "/account/" +
          account.name.trim().replace(" ", "_") +
          "/" +
          (e.id ? e.id : 0);

        this.$router.push(uri);
      });
    },
    onSubmit(e) {
      e.preventDefault();
      debugger;
      this.isSubmitting = true;
      var site = this.$store.getters["accounts/currentSite"];

      if (site) {
        //is this a new site?
        if (!site.id) {
          this.selectedAccount.sites.push(site); // add to list then submit update.
        }
      }

      if (!this.selectedAccount.id) {
        return this.$store.dispatch("accounts/addAccount").then(rsp => {
          if (rsp) {
            // this.$router.push({ name: "accounts" });
            this.reset();
          }
        });
      } else {
        return this.$store.dispatch("accounts/updateAccount").then(rsp => {
          this.reset();
          //   if (rsp) {
          //     this.selectedAccount = null;
          //     this.$router.push({ name: "accounts" });
          //   }
        });
      }
    },
    reset() {
      return (
        this.$store
          .dispatch("accounts/getAccounts")
          // .then(() => this.$router.push("/admin/accounts"))
          .then(() => (this.showSiteEditor = false))
          .then(() => (this.wasModified = false))
          .then(() => (this.selectedAccount = null))
          .then(() => (this.isSubmitting = false))
          .then(() => (window.location = "#/admin/accounts"))
      );
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/account.vue